import { useEffect, useState } from 'react';

interface CustomCursorProps {
  mousePosition: { x: number; y: number };
}

export default function CustomCursor({ mousePosition }: CustomCursorProps) {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    setCursorPosition(mousePosition);

    const checkHover = () => {
      const elements = document.querySelectorAll('a, button, [role="button"]');
      let hovering = false;

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (
          mousePosition.x >= rect.left &&
          mousePosition.x <= rect.right &&
          mousePosition.y >= rect.top &&
          mousePosition.y <= rect.bottom
        ) {
          hovering = true;
        }
      });

      setIsHovering(hovering);
    };

    checkHover();
  }, [mousePosition]);

  return (
    <>
      <div
        className="fixed pointer-events-none z-[9999] mix-blend-difference transition-transform duration-150"
        style={{
          left: `${cursorPosition.x}px`,
          top: `${cursorPosition.y}px`,
          transform: `translate(-50%, -50%) scale(${isHovering ? 1.5 : 1})`,
        }}
      >
        <div className="w-3 h-3 bg-white rounded-full" />
      </div>

      <div
        className="fixed pointer-events-none z-[9998] transition-all duration-300"
        style={{
          left: `${cursorPosition.x}px`,
          top: `${cursorPosition.y}px`,
          transform: `translate(-50%, -50%) scale(${isHovering ? 1.2 : 1})`,
        }}
      >
        <div className="w-8 h-8 border border-white/30 rounded-full backdrop-blur-sm" />
      </div>
    </>
  );
}
